import React from 'react';

const ResponsiveBanner = () => {
  const BannerContent = {
    bannerText: '! طلای آب شده ، خرید امن و بدون واسطه',
    backgroundColor: '#01494b',
    textColor: '#fff',
  };

  return (
    <div className='gold-banner-container'>
      <div className='gold-banner-wrapper'>
        <a
          href={'/gold-trading'}
          className='gold-banner-content'
          style={{
            backgroundColor: BannerContent.backgroundColor,
            color: BannerContent.textColor,
            display: 'block',
            textDecoration: 'none',
          }}
        >
          <h1
            className='gold-banner-heading'
            style={{
              color: BannerContent.textColor,
            }}
          >
            {BannerContent.bannerText}
          </h1>
        </a>
      </div>
    </div>
  );
};

export default ResponsiveBanner;
